import React, { useState } from 'react';
import { useAppSelector } from '../../store/hooks';
import { graphqlRequest } from '../../service/graphql-client';
import { GQ_CHANGE_PASSWORD } from '../../service/graphql-mutations';

export default function ChangePasswordModal({ onClose }) {
  const { accessToken } = useAppSelector((state) => state.auth);
  const [formData, setFormData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  });
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    // Clear error message when user starts typing
    if (errorMessage) {
      setErrorMessage('');
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    setErrorMessage('');
    setSuccessMessage('');

    // Validation
    if (formData.newPassword !== formData.confirmPassword) {
      setErrorMessage('New passwords do not match');
      setIsLoading(false);
      return;
    }

    if (formData.newPassword.length < 6) {
      setErrorMessage('New password must be at least 6 characters long');
      setIsLoading(false);
      return;
    }

    try {
      const data = await graphqlRequest(GQ_CHANGE_PASSWORD, {
        currentPassword: formData.currentPassword,
        newPassword: formData.newPassword
      }, accessToken);

      if (data.changePassword && data.changePassword.success) {
        setSuccessMessage('Password changed successfully!');
        // Clear form
        setFormData({
          currentPassword: '',
          newPassword: '',
          confirmPassword: ''
        });
      } else {
        setErrorMessage(data.changePassword?.message || 'Failed to change password');
      }
    } catch (error) {
      setErrorMessage(error.message || 'Failed to change password. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div className="modal-header">
        <h2 className="modal-title">Change Password</h2>
      </div>
      <div className="modal-body saveBuildModalBody">
        <form onSubmit={handleSubmit}>
          <div>
            <label htmlFor="currentPassword">Current Password:</label> <br />
            <input 
              className="input_100" 
              name="currentPassword" 
              type="password" 
              value={formData.currentPassword}
              onChange={handleInputChange}
              required 
            />
          </div>
          <div>
            <label htmlFor="newPassword">New Password:</label> <br />
            <input 
              className="input_100" 
              name="newPassword" 
              type="password" 
              value={formData.newPassword}
              onChange={handleInputChange}
              required 
            />
          </div>
          <div>
            <label htmlFor="confirmPassword">Confirm New Password:</label> <br />
            <input 
              className="input_100" 
              name="confirmPassword" 
              type="password" 
              value={formData.confirmPassword}
              onChange={handleInputChange}
              required 
            />
          </div>
          <div>
            <button 
              type="submit" 
              className="orange-button button saveBuildButton"
              disabled={isLoading}
            >
              {isLoading ? 'Changing Password...' : 'Change Password'}
            </button>
          </div>
        </form>
        {errorMessage && <div className="error-message">{errorMessage}</div>}
        {successMessage && <div className="success-message">{successMessage}</div>}
        <div className="backToLogin">
          <a href="#" onClick={onClose} className="link-button">Back to Profile</a>
        </div>
      </div>
    </>
  );
}
